import axios from "axios";
import { downloadFile } from "common/utility";
import { API_URL } from "apiConfig";

export const axiosApi = axios.create({
  baseURL: API_URL,
  timeout: 15000, // 15 second timeout for WiFi connections
  headers: {
    'Content-Type': 'application/json',
  }
});

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then((response) => response.data);
}
export async function getWithExportFile(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then((response) => {
    if (response.status && !response.data.data) {
      const fileUrl = URL.createObjectURL(
        new Blob([response.data], { type: `text/csv` })
      );
      downloadFile(fileUrl, `${url.split("/")[1]}_${Date.now()}.csv`);
    }
    return response.data;
  });
}

export async function postWithExportFile(url, data, config = {}) {
  return await axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => {
      if (response.status && !response.data.data) {
        const fileUrl = URL.createObjectURL(
          new Blob([response.data], { type: `text/csv` })
        );
        downloadFile(fileUrl, `${url.split("/")[1]}_${Date.now()}.csv`);
      }
      return response.data;
    });
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function patch(url, data, config = {}) {
  return axiosApi
    .patch(url, { ...data }, { ...config })
    .then((response) => response.data);
}


export async function postAsForm(url, data, config = {}) {
  return axiosApi
    .post(url, data, { ...config })
    .then((response) => response.data);
}
export async function putAsForm(url, data, config = {}) {
  return axiosApi
    .put(url, data, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

// export async function del(url, id, config = {}) {
//   return await axiosApi
//     .delete(
//       url,
//       {
//         params: { id },
//       },
//       { ...config }
//     )
//     .then((response) => response.data);
// }
export async function del(url, id, config = {}) {
  return await axiosApi
    .delete(url, {
      params: { id },
      ...config,
    })
    .then((response) => response.data);
}

// export const apiHeader = () => {
//   let obj = "";
//   if (typeof window !== "undefined") {
//     obj = JSON.parse(localStorage.getItem("authUser"));
//   }
//   if (obj && obj.token) {
//     axiosApi.defaults.headers.common["Authorization"] = obj.token;
//   } else {
//     return {};
//   }
// };

axiosApi.interceptors.response.use(
  (response) => {
    console.log("✅ Response received:", response.config.url, "Status:", response.status);
    return response;
  },
  (error) => {
    console.log("❌ API Error:", {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data
    });
    
    if (error.response && error.response.status === 401) {
      console.error("🚨 401 Unauthorized Error on:", error.config?.url);
      console.error("📋 Error response data:", error.response?.data);
      console.error("📦 Current authUser:", localStorage.getItem("authUser"));
      // Handle the session expiry
      handleSessionExpiry();
    }
    return Promise.reject(error);
  }
);

const handleSessionExpiry = () => {
  // errorToast("Session Expired!");
  // Clear any authentication tokens or user data here
  localStorage.removeItem("authUser");
  // Redirect to the login page
  window.location.href = "/";
};

axiosApi.interceptors.request.use(
  (config) => {
    try {
      const raw = localStorage.getItem("authUser");
      if (!raw) {
        console.log("🔴 No authUser found in localStorage");
        return config;
      }

      const obj = JSON.parse(raw);
      console.log("📦 STEP 1: Get authUser from localStorage", obj);
      
      // Try multiple possible token field names
      // Based on your login response: data.data.token is the structure
      const token =
        obj?.token ||
        obj?.accessToken ||
        obj?.authToken ||
        obj?.jwt ||
        obj?.authorization ||
        obj?.data?.data?.token ||  // Your actual token location
        obj?.data?.token ||
        obj?.data?.accessToken ||
        obj?.user?.token ||
        obj?.result?.token ||
        obj?.result?.accessToken;

      console.log("🔑 STEP 2: Extracted token", token ? "✅ Token found" : "❌ No token found");
      
      if (!token) {
        console.error("❌ Token extraction failed. Full object structure:", JSON.stringify(obj, null, 2));
        console.error("Available keys:", Object.keys(obj));
        return config;
      }

      console.log("🎫 STEP 3: Token value:", token.substring(0, 30) + "...");
      
      const value = token.startsWith("Bearer ") ? token : `Bearer ${token}`;
      config.headers.Authorization = value;
      
      console.log("✅ STEP 4: Authorization header set for:", config.url);
      console.log("📡 Request Config:", {
        url: config.url,
        method: config.method,
        hasAuth: !!config.headers.Authorization,
        authHeader: config.headers.Authorization?.substring(0, 30) + "..."
      });
    } catch (e) {
      console.error("❌ Error in request interceptor:", e);
    }
    return config;
  },
  (error) => Promise.reject(error)
);
